import React from "react"
import { Form as FormAntd } from "antd"

export const Form = FormAntd
